import React, { useState } from 'react';
import { Lock } from 'lucide-react';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { Label } from '../ui/label';
import { Card, CardContent } from '../ui/card';

/** Reusable admin login card used by /admin/submissions and /admin/blog. */
const AdminLoginCard = ({ onLogin, subtitle }) => {
  const [password, setPassword] = useState('');
  const [isChecking, setIsChecking] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!password) return;
    setIsChecking(true);
    try {
      await onLogin(password);
    } finally {
      setIsChecking(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center px-4 bg-gradient-to-br from-blue-50 to-white">
      <Card className="w-full max-w-md border-2">
        <CardContent className="p-8 space-y-6">
          <div className="flex items-center justify-center space-x-3">
            <div className="bg-blue-100 rounded-full p-3">
              <Lock className="w-6 h-6 text-blue-600" />
            </div>
            <h1 className="text-2xl font-bold text-gray-900">Admin Access</h1>
          </div>
          <p className="text-sm text-gray-600 text-center">
            {subtitle || 'Enter the admin password to continue.'}
          </p>
          <form onSubmit={handleSubmit} className="space-y-4">
            <div>
              <Label htmlFor="admin-password">Password</Label>
              <Input
                id="admin-password"
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                autoFocus
                className="mt-2"
                data-testid="admin-password-input"
              />
            </div>
            <Button
              type="submit"
              className="w-full bg-coral-500 hover:bg-coral-600 text-white"
              disabled={isChecking || !password}
              data-testid="admin-login-button"
            >
              {isChecking ? 'Verifying…' : 'Sign In'}
            </Button>
          </form>
        </CardContent>
      </Card>
    </div>
  );
};

export default AdminLoginCard;
